import React, { useState, useEffect } from 'react';

// Services API
import { GetProjects } from '../services/getData';

const Context = React.createContext({});

export function ProjectsContextProvider({ children }) {
	const [refresh, setRefresh] = useState(false);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [dataList, setDataList] = useState([]);

	useEffect(() => {
		GetProjects({ setDataList, setLoading, setError });
		setRefresh(false);
	}, [setDataList, refresh]);

	return (
		<Context.Provider
			value={{
				dataList,
				setDataList,
				loading,
				setLoading,
				error,
				setError,
				setRefresh,
			}}
		>
			{children}
		</Context.Provider>
	);
}

export default Context;
